import { request } from '../utils/request';

/**
 * 获取用户权限列表
 * 接口: POST /api/Usersystempermissionsmapping/GetListAsync
 * 请求体: { loginId?, clientId?, status? } 无分页，返回全量
 */
export const getListAsync = (data = {}) => {
  return request({
    url: 'Usersystempermissionsmapping/GetList',
    method: 'post',
    data: {
      loginId: data.loginId ?? data.LoginId ?? '',
      clientId: data.clientId ?? data.ClientId ?? '',
      status: data.status ?? data.Status,
    },
  });
};

/** @deprecated 请使用 getListAsync */
export const getUserSystemPermissionsPageList = (data) => {
  return getListAsync({
    loginId: data?.LoginId,
    clientId: data?.ClientId,
    status: data?.Status,
  });
};

/**
 * 批量停用/启用权限
 * 接口: POST /api/Usersystempermissionsmapping/UpdateStatusAsync
 * 请求体: { status: 0|1, ids: number[] }
 */
export const updateStatusAsync = (data) => {
  return request({
    url: 'Usersystempermissionsmapping/UpdateStatus',
    method: 'post',
    data: {
      status: data.status ?? data.Status,
      ids: data.ids ?? data.Ids ?? [],
    },
  });
};

/** @deprecated 请使用 updateStatusAsync */
export const updateUserSystemPermissionsStatus = (data) => {
  return updateStatusAsync(data);
};

/**
 * 新增用户权限
 * 接口: POST /api/Usersystempermissionsmapping/AddAsync
 * 请求体: { loginId, clientId, remark? }
 */
export const addAsync = (data) => {
  return request({
    url: 'Usersystempermissionsmapping/Add',
    method: 'post',
    data: {
      loginId: data.loginId ?? data.LoginId,
      clientId: data.clientId ?? data.ClientId,
      remark: data.remark,
    },
  });
};

/** @deprecated 请使用 addAsync */
export const addUserSystemPermissions = (data) => {
  return addAsync(data);
};
